import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "team",
  class: "team-wrap ptb-100"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "team-slider-one style1" }
const _hoisted_4 = { class: "team-card style8" }
const _hoisted_5 = { class: "team-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "team-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-2" }, [
          _createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
            _createElementVNode("span", null, "Our Doctors"),
            _createElementVNode("h2", null, "We provide Exceptional Medical Care For Our Patients")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Carousel, {
          autoplay: 5000,
          "wrap-around": true,
          breakpoints: _ctx.breakpoints,
          "pause-autoplay-on-hover": "",
          class: "team-slider-one style1"
        }, {
          addons: _withCtx(() => [
            _createVNode(_component_Pagination)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
              return (_openBlock(), _createBlock(_component_Slide, {
                key: team.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: team.image,
                        alt: "Image"
                      }, null, 8, _hoisted_6),
                      _cache[0] || (_cache[0] = _createElementVNode("ul", { class: "social-profile list-style style1" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            target: "_blank",
                            href: "https://facebook.com"
                          }, [
                            _createElementVNode("i", { class: "ri-facebook-line" })
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            target: "_blank",
                            href: "https://twitter.com"
                          }, [
                            _createElementVNode("i", { class: "ri-twitter-line" })
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            target: "_blank",
                            href: "https://instagram.com"
                          }, [
                            _createElementVNode("i", { class: "ri-instagram-line" })
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            target: "_blank",
                            href: "https://linkedin.com"
                          }, [
                            _createElementVNode("i", { class: "ri-linkedin-line" })
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h3", null, _toDisplayString(team.name), 1),
                      _createElementVNode("span", null, _toDisplayString(team.designation), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["breakpoints"])
      ])
    ])
  ]))
}